module.exports = __webpack_public_path__ + "img/pt-BR.20797008.svg";